export const Menu = {
  menu: [
    {
      label: "Home",
      section: "#home",
      className: "bx-home",
    },
    {
      label: "About me",
      section: "#profile",
      className: "bx-user",
    },
    {
      label: "Skills",
      section: "#skills",
      className: "bx-receipt",
    },
    {
      label: "Experience",
      section: "#experience",
      className: "bx-briefcase-alt",
    },
    {
      label: "Education and training",
      section: "#education",
      className: "bx-book",
    },
  ],
};
